<template lang="pug">
    div
        manager-wholesale-discounts(submitText="Crear esquema" crudOption="create"
            @clear-form="clearForm"
            @submit-form="submitForm"
            @cancel-editing="restartEditing"
            )
            product-data
</template>

<script>
import InputValidations from '@/mixins/InputValidations.js'
import CurrencyUtils from '@/mixins/CurrencyUtils.js'
import ManagerWholesaleDiscounts from '@/components/WholesaleDiscount/Manager'
import SnackbarModalUtils from '@/mixins/SnackbarModalUtils'
import ProductData from './ProductData'

import ProductsWholesaleDiscountService from '@/services/api/product/ProductsWholesaleDiscountService'
import { mapActions, mapState } from 'vuex'
export default {
    name: 'component-name',
    props: {},
    data: function() {
        return {}
    },
    computed: {
        ...mapState('WholesaleDiscountModule', {
            arrayDiscounts: 'arrayDiscounts',
            id: 'id',
        }),
    },
    methods: {
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),

        ...mapActions('WholesaleDiscountModule', {
            resetArrayDiscounts: 'resetArrayDiscounts',
            addDiscount: 'addDiscount',
            resetStateWholesaleDiscount: 'resetState',
            setGlobalPercentageDiscount: 'setGlobalPercentageDiscount',
            setId: 'setId',
            restartEditingWholesaleDiscount: 'restartEditing',

        }),

        restartEditing(){
            this.restartEditingWholesaleDiscount()
        },
        
        // returnPreviousRoute() {
        //     this.$router.push({ path: `/products/${this.idProduct}` })
        // },

        clearForm(){
            this.resetArrayDiscounts()
        },

        async submitForm() {
            let snackLoading = this.fillSnack(
                'info',
                'Creando',
                'Espere un momento',
                true,
                6000
            )
            this.initSnackbar(snackLoading)
            let response = await ProductsWholesaleDiscountService.createWholeSaleDiscounts(
                this.arrayDiscounts,
                this.id
            )
            if (response.status == 'success') {

                let snackInfo = this.fillSnack(
                    'success',
                    'Éxito',
                    'El esquema de descuentos se ha guardado exitosamente',
                    false,
                    6000
                )
                this.initSnackbar(snackInfo)
                this.$router.push({ path: `/products/${this.idProduct}` })
            } else {
                //TODO: test response error from backend
                let snackInfo = this.fillSnack(
                    'error',
                    'Error',
                    response,
                    false,
                    3000
                )
                this.initSnackbar(snackInfo)
            }
        },


        fillStaticFormData() {
            let information = {}
            information.toolbarTitle = 'Nuevo esquema descuentos Familia'
            information.toolbarIcon = 'close'
            information.customRules = function(value) {
                return isNaN(value) ? true : 'Debe ingresar un número.'
            }
            information.editable = false
            information.disabled = false
            information.submitText = 'Guardar esquema descuentos'

            return information
        },
    },
    watch: {},
    components: { ManagerWholesaleDiscounts, ProductData },
    mixins: [InputValidations, CurrencyUtils, SnackbarModalUtils],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    beforeMount: async function() {
        let idProduct = this.$route.params.id
        let whDiscounts = await ProductsWholesaleDiscountService.fetchWholesaleDiscountsProduct(idProduct)
        if(whDiscounts === null || whDiscounts.length === 0){ // Wholesale discounts should be created
            this.resetStateWholesaleDiscount()
            this.setGlobalPercentageDiscount(false)
            this.addDiscount()
            this.setId(idProduct)
        }else{ // Wholesale discounts should be shown/edited
            this.$router.push({ path: `/products/${idProduct}/wholesale_discounts` })
        }
    },
    mounted: function() {
        this.setTitleTopBar('CREAR ESQUEMA DESCUENTOS PRODUCTO')
    },
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss">
</style>